import { h, Component } from 'preact';
import Button from 'q-mdc/elements/material-button';
import Textfield from 'q-mdc/quikr/core/text-field';
import List from 'q-mdc/elements/material-list';
import ListItem from 'q-mdc/elements/material-list-item';
import Loader from '../../vap-components/loader';
import { sendOtp, verifyOtp, resendOtp } from '../../../utils/VapHelper';
import { pushToDataLayer } from '../../../utils/CommonHelper';
import './index.scss';

class Otp extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            showLoader: false,
            otpResend: false,
            otpText: "We have sent the OTP on"
        }
        this.mobile = this.props.mobile;
    }

    componentDidMount() {
        this.generateOtp();
    }

    generateOtp = () => {
        sendOtp(this.mobile, this.props.csrf).then((response)=>{
            this.props.sendOtpEvent && pushToDataLayer({event: this.props.sendOtpEvent});
            if (response.data.status === 200) {

            } else if(response.data.error && response.data.message) {
                alert(response.data.message);
            } else {
                alert('Something went wrong');
            }
        })
    }

    verifyOtp = (e) => {
        e && e.preventDefault();
        if (!/[0-9]{4}/.test(this.state.otp)) {
            this.setState({
                otpError: 'Enter valid OTP'
            })
            return;
        }
        verifyOtp(this.state.otp,this.mobile,this.props.csrf).then((response)=>{
            this.props.verifyOtpEvent && pushToDataLayer({event: this.props.verifyOtpEvent});
            if (response.data.status == 'SUCCESS') {
                this.setState({
                    showLoader: true,
                },() => {
                    this.props.successCallBack();
                })
            } else {
                if (response.data.error == 'Please enter correct OTP') {
                    alert(response.data.error);
                } else if (response.data.message) {
                    alert(response.data.message);
                } else {
                    alert('Something went wrong at our end. Please try after sometime.');
                }
            }
        })
    }

    handleOtp = (e) => {
        if (/[0-9]{4}/.test(e.target.value)) {
            this.setState({
                otp: e.target.value
            },()=>{
                this.verifyOtp();
            });
        }
    }

    handleOtpChange = (e) => {
        this.setState({otp: e.target.value});
    }

    resendOtp = (e) => {
        e && e.preventDefault();
        resendOtp(this.props.csrf).then((response)=>{
            this.props.resendOtpEvent && pushToDataLayer({event: this.props.resendOtpEvent});
            if (response.data.status == 200) {
                this.setState({
                    otpResend: true,
                    otpText: "OTP has been resent to"
                })
            } else if(response.data.error && response.data.message) {
                alert(response.data.message);
            } else {
                alert('Something went wrong');
            }
        })
    }

    render() {
        return(
            <div class="otp-cont">
                <div class="otp-header">
                    <label>{this.state.otpText}</label>
                    <p>{this.mobile} - <span onClick={this.props.openInput}>Change</span></p>
                </div>
                <List>
                    <ListItem class="otp-title">Enter OTP</ListItem>
                    <ListItem>
                        <div class="qc__otp-verify">
                            <div class="qc__otp-verify--input-wrap">
                                <div class="input-wrap__border1"> 
                                    <div class="input-wrap__border2">
                                        <Textfield fullWidth id="qc__otp-verify--input" oninput={this.handleOtp} onChange={this.handleOtpChange} type="tel" error={this.state.otpError} value={this.state.otp} maxlength="4" required />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ListItem>
                    <ListItem>
                        {this.state.showLoader ? 
                            <Loader /> 
                            : 
                            <Button primary={true} unelevated={true} ripple={true} onClick={this.verifyOtp}>VERIFY OTP</Button>
                        }
                    </ListItem>
                    <ListItem class="resend-link">Didn't get it? <strong title="Resend OTP" onClick={this.resendOtp}>Resend OTP</strong></ListItem>
                </List>
            </div>
        )
    }
}

export default Otp;


// WEBPACK FOOTER //
// ../q-cars/src/components/common/otp/index.js